/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmProxyContractInfo = {
    PRXTP: EvmProxyContractInfo.PRXTP;
    PRXEIP: string;
    IPADDR: string;
};

export namespace EvmProxyContractInfo {

    export enum PRXTP {
        Y = 'Y',
        N = 'N',
    }


}

